import { Navigate, Route, Routes } from 'react-router-dom';

import { DashboardLayout } from '../components/layout/dashboard-layout';
import { BankAccountsOverview } from '../pages/bank-accounts';
import CompleteRegistration from '../pages/complete-registration';
import { ContractsOverview } from '../pages/contracts';
import { AutoPayLink } from '../pages/contracts/AutoPayLink';
import ContractDetails from '../pages/contracts/contractDetails';
import { DashboardHome } from '../pages/dashboard/dashboard-home';
import DashboardMakePayment from '../pages/dashboard/DashboardMakePayment';
import { DocumentsOverview } from '../pages/documents/documents';
import ElloMakePayments from '../pages/ello-make-payments';
import { MakePaymentLink } from '../pages/make-payment/MakePaymentLink';
import { NotFound } from '../pages/not-found';
import { PaymentsOverview } from '../pages/payments';
import { CreatePayment } from '../pages/payments/create-payment';
import { OpenInvoicesLink } from '../pages/payments/OpenInvoicesLink';
import { SelfRegistration } from '../pages/self-registration';
import { Settings } from '../pages/settings';
import { SupportOverview } from '../pages/support';
import { NavigationConfig } from '../utils/navigation-constants';

export const PostAuthenticatedRoutes = () => {
    return (
        <Routes>
            {/* Ello email-link confirmation: full URL path on any portal host; works logged-in without dashboard chrome */}
            <Route path={NavigationConfig.ElloPaymentConfirm} element={<ElloMakePayments />} />
            <Route path={NavigationConfig.ElloMakePayments} element={<ElloMakePayments />} />
            {/* Admin-assisted registration invite link: works even if an old session cookie is still active */}
            <Route path={NavigationConfig.CompleteRegistration} element={<CompleteRegistration />} />
            {/* Self-registration flow: accessible even when logged in (e.g., admins in impersonate mode) */}
            <Route path={NavigationConfig.SelfRegistration} element={<SelfRegistration />} />
            {/* AutoPay link: ?contractID=abc parameter for direct autopay access */}
            <Route path={NavigationConfig.AutoPayLink} element={<AutoPayLink />} />
            {/* Make Payment link: ?contractID=abc parameter for direct make-payment access */}
            <Route path={NavigationConfig.MakePayment} element={<MakePaymentLink />} />
            {/* Open Invoices link: opens payments page with open-invoices tab */}
            <Route path={NavigationConfig.OpenInvoicesLink} element={<OpenInvoicesLink />} />
            <Route path="/" element={<DashboardLayout />}>
                <Route index element={<Navigate to={NavigationConfig.ContractOverview} replace />} />
                <Route path={NavigationConfig.Home} element={<DashboardHome />} />
                <Route path={NavigationConfig.DocumentOverview} element={<DocumentsOverview />} />
                <Route path={NavigationConfig.Payments} element={<PaymentsOverview />} />
                <Route path={NavigationConfig.MakePayment} element={<CreatePayment />} />
                <Route path={NavigationConfig.DashboardMakePayment} element={<DashboardMakePayment />} />
                <Route path={NavigationConfig.ContractOverview} element={<ContractsOverview />} />
                <Route path={NavigationConfig.ContractDetails} element={<ContractDetails />} />
                <Route path={NavigationConfig.Support} element={<SupportOverview />} />
                <Route path={NavigationConfig.Settings} element={<Settings />} />
                <Route path={NavigationConfig.BankAccounts} element={<BankAccountsOverview />} />
            </Route>
            <Route
                path={NavigationConfig.Login}
                element={<Navigate to={NavigationConfig.ContractOverview} replace />}
            />
            <Route
                path={NavigationConfig.UpgradeAnnouncement}
                element={<Navigate to={NavigationConfig.Home} replace />}
            />
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
};
